import React from "react";
import { NavLink } from "react-router-dom";
import { Home, Users, Briefcase, Megaphone, Calendar } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const ITEMS = [
  { to: "/dashboard", label: "Home", icon: Home },
  { to: "/members", label: "Members", icon: Users },
  { to: "/businesses", label: "Business", icon: Briefcase },
  { to: "/opportunities", label: "Deals", icon: Megaphone },
  { to: "/events", label: "Events", icon: Calendar },
];

export function MobileTabBar() {
  const { user } = useAuth();
  if (!user || typeof user !== "object") return null;
  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-40 border-t border-slate-200 bg-white/95 backdrop-blur-md lg:hidden"
      data-testid="mobile-tab-bar"
    >
      <div className="grid grid-cols-5">
        {ITEMS.map(({ to, label, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            end={to === "/dashboard"}
            data-testid={`tab-${label.toLowerCase()}`}
            className={({ isActive }) =>
              `flex flex-col items-center gap-1 py-2.5 text-[10px] font-medium transition-colors ${
                isActive ? "text-[#B8860B]" : "text-slate-500"
              }`
            }
          >
            <Icon className="h-5 w-5" />
            {label}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}

export default MobileTabBar;
